/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Directory_Platforms_Listing_Empty_TitleInputs */

const en_directory_platforms_listing_empty_title = /** @type {(inputs: Directory_Platforms_Listing_Empty_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.platform} products yet`)
};

const zh_directory_platforms_listing_empty_title = /** @type {(inputs: Directory_Platforms_Listing_Empty_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`暂时没有 ${i?.platform} 产品`)
};

/**
* | output |
* | --- |
* | "No {platform} products yet" |
*
* @param {Directory_Platforms_Listing_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_listing_empty_title = /** @type {((inputs: Directory_Platforms_Listing_Empty_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Listing_Empty_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_listing_empty_title(inputs)
	return zh_directory_platforms_listing_empty_title(inputs)
});
export { directory_platforms_listing_empty_title as "directory.platforms.listing_empty_title" }